module.exports = __webpack_public_path__ + "img/c01_unitvillager_Normal_ua.2ad95c66.webp";